'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalOverviewComponent = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rentalOverviewComponent = exports.rentalOverviewComponent = {
    template: require('./rental-overview.html'),
    controllerAs: 'vm',
    bindings: {
        tgzId: '<',
        statuses: '<'
    },
    controller: ["rentalProductsService", "config", "common", "gettextCatalog", "$stateParams", "authService", "$q", "Analytics", function rentalOverviewController(rentalProductsService, config, common, gettextCatalog, $stateParams, authService, $q, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.productsLoading = false;
        vm.ordersLoading = false;
        vm.recentRentEndedProductsLoading = false;
        vm.loadOrders = loadOrders;
        vm.getDownloadUrl = getDownloadUrl;
        vm.getInRentStatus = getInRentStatus;
        vm.getRentEndedStatus = getRentEndedStatus;
        vm.rentingProductsTotalCount = 0;
        vm.recentRentEndedProductsCount = 0;
        vm.rentEndedProductsTotalCount = 0;
        vm.ordersTotalCount = 0;

        function init() {
            common.setTitle(gettextCatalog.getString('My rent overview'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/rentals', gettextCatalog.getString('My rent overview'));
            loadInRentProducts();
            loadRecentRentEndedProducts();
            loadOrders();
        }

        function loadInRentProducts() {
            vm.productsLoading = true;
            var search = {
                skip: 0,
                take: 15,
                statusId: vm.getInRentStatus().id
            };
            rentalProductsService.getRentalHistory(search).then(function (response) {
                vm.products = response.results;
                vm.rentingProductsTotalCount = response.count;
                vm.productsLoading = false;
            });
        }

        function loadRecentRentEndedProducts() {
            vm.recentRentEndedProductsLoading = true;
            var search = {
                skip: 0,
                take: 15,
                statusId: vm.getRentEndedStatus().id,
                minDate: (0, _moment2.default)().add(-3, 'months').format('YYYY-MM-DD')
            };
            var totalCountSearch = {
                skip: 0,
                take: 1,
                statusId: vm.getRentEndedStatus().id
            };
            $q.all([rentalProductsService.getRentalHistory(search), rentalProductsService.getRentalHistory(totalCountSearch)]).then(function (response) {
                vm.rentEndedProducts = response[0].results;
                vm.recentRentEndedProductsCount = response[0].count;
                vm.rentEndedProductsTotalCount = response[1].count;
                vm.recentRentEndedProductsLoading = false;
            });
        }

        function loadOrders() {
            vm.ordersLoading = true;
            var search = {
                skip: 0,
                take: 15,
                minDate: (0, _moment2.default)().add(-3, 'months').format('YYYY-MM-DD')
            };
            rentalProductsService.searchRentalOrders(search).then(function (response) {
                vm.orders = response.results;
                vm.ordersTotalCount = response.count;
                vm.ordersLoading = false;
            });
        }

        function getInRentStatus() {
            return vm.statuses.find(function (x) {
                return x.code === '20';
            });
        }

        function getRentEndedStatus() {
            return vm.statuses.find(function (x) {
                return x.code === '40';
            });
        }

        function getDownloadUrl(rentalOrder) {
            return config.webApiBaseUrl + ('report/rentalOrderDetail/' + rentalOrder.id + '?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/rental-overview.js
// module id = 888
// module chunks = 0